if (!customElements.get("featured-collection")) {
  console.log('hsgdhsfghf');
  customElements.define(
    "featured-collection",
    class FeaturedCollection extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: ".featured-collection__items",
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        };
        this.classes = {
          grid: "f-grid",
          swiper: "swiper",
          swiperWrapper: "swiper-wrapper",
        };

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

        this.enableSlider = this.dataset.enableSlider === "true";
        this.items = parseInt(this.dataset.items);
        this.tabletItems = parseInt(this.dataset.tabletItems);

        this.sliderInstance = false;

        if (!this.enableSlider) return;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        this.initSlider();

        const isMobile = window.innerWidth <= 768;
        const sTShow = isMobile ? 1.3 : this.items;
        const totalSlides = this.sliderInstance?.slider?.slides?.length || 0;
        const allVisible = sTShow >= totalSlides;
        const slidesToShow = Math.min(sTShow, totalSlides);

        console.log(allVisible, sTShow, totalSlides,slidesToShow,'allVisible>>')
        if (allVisible) {
          this.startManualAutoplayCycle();
        }

        const controlsEl = this.section.querySelector(
          ".swiper-controls--inside"
        );
        if (controlsEl) {
          controlsEl.classList.toggle("hidden", allVisible);
          controlsEl.classList.toggle("md:block", !allVisible);
        }
      }

      startManualAutoplayCycle() {
        const isMobile = window.innerWidth <= 768;
        const swiper = this.sliderInstance?.slider;
        if (!swiper) return;
        console.log("call startManualAutoplayCycle", swiper);

        const slides = swiper.slides;
        if (!slides || slides.length === 0) return;

        swiper.wrapperEl.classList.add('justify-center');
        swiper.wrapperEl.classList.add('items-start');

        this.manualVideoIndex = 0;

        const playNextVideo = () => {
          slides.forEach((slide) => {
            const video = slide.querySelector("video");
            if (video) {
              video.pause();
              video.currentTime = 0;
              video.onended = null;
            }
            slide.classList.remove("swiper-slide-active");
          });

          const currentSlide = slides[this.manualVideoIndex];
          if (!currentSlide) return;

          currentSlide.classList.add("swiper-slide-active");

          document
            .querySelectorAll(".product-info")
            .forEach((el) => el.classList.remove("active"));
          const info = document.getElementById(
            `product-info-${this.manualVideoIndex + 1}`
          );
          if (info) info.classList.add("active");

          

          if(!isMobile) {
            const info2 = document.getElementById(
              `product-info-upper-${this.manualVideoIndex + 1}`
            );
            if (info2) info2.classList.add("active");
          }

          const video = currentSlide.querySelector("video");

          if (video) {
            // Check if video is loaded and duration available
            const tryPlay = () => {
              if (isNaN(video.duration)) {
                video.addEventListener(
                  "loadedmetadata",
                  () => {
                    video.play().catch(() => {});
                    video.onended = () => {
                      this.manualVideoIndex =
                        (this.manualVideoIndex + 1) % slides.length;
                      playNextVideo();
                    };
                  },
                  { once: true }
                );
              } else {
                video.play().catch(() => {});
                video.onended = () => {
                  this.manualVideoIndex =
                    (this.manualVideoIndex + 1) % slides.length;
                  playNextVideo();
                };
              }
            };

            tryPlay();
          } else {
            clearTimeout(this.imageSlideTimer);

            // No video: fallback to timeout
            const fallbackTime = 3000;

            this.imageSlideTimer = setTimeout(() => {
              if (swiper.slides[swiper.activeIndex] === currentSlide) {
                this.manualVideoIndex =
                  (this.manualVideoIndex + 1) % slides.length;
                playNextVideo();
              }
            }, fallbackTime);
          }
        };

        playNextVideo();
      }

      initSlider() {
        if (typeof this.sliderInstance === "object") return;

        const isMobile = window.innerWidth <= 768;

        const columnGap = window
          .getComputedStyle(this.sliderWrapper)
          .getPropertyValue("--column-gap");
        const spaceBetween = parseFloat(columnGap.replace("rem", "")) * 10;
        const isIndex = document.body.classList.contains("index-template") || document.body.classList.contains("template__lookbook");
        console.log(this.items, "<<<itttt")

        this.sliderOptions = {
          slidesPerView: isMobile ? 1.3 : this.items,
          centeredSlides: isMobile || isIndex,
          loop: isMobile || isIndex,
          spaceBetween: 20,
          speed: 600,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          pagination: {
            el: ".swiper-paginations",
            clickable: true,
          },
          on: {
            slideChangeTransitionStart: function () {
              const index = this.realIndex;

              // Pause all videos
              document
                .querySelectorAll(".swiper-slide video")
                .forEach((video) => video.pause());

              // Play video in the active slide
              const activeSlide = this.slides[this.activeIndex];
              const video = activeSlide.querySelector("video");
              if (video) video.play();

              // Update product info
              document
                .querySelectorAll(".product-info")
                .forEach((el) => el.classList.remove("active"));
              console.log(index, "index>>>>>>");
              const info = document.getElementById(`product-info-${index + 1}`);
              if (info) info.classList.add("active");

              if(!isMobile) {
                const info2 = document.getElementById(
                  `product-info-upper-${this.manualVideoIndex + 1}`
                );
                if (info2) info2.classList.add("active");
              }
            },
          },
        };

        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(
          this,
          this.sliderOptions
        );
        this.sliderInstance.init();

        // Optional: Log real active slide
        this.sliderInstance.slider.on("slideChange", () => {
          const swiper = this.sliderInstance.slider;
          const realIndex = swiper.realIndex;
          console.log("Real index:", realIndex);
        });

        // Set pointer + click center logic
        this.sliderInstance.slider.slides.forEach((slide) => {
          slide.style.cursor = "pointer";
          slide.addEventListener("click", () => {
            const swiper = this.sliderInstance.slider;
            const clickedIndex = parseInt(
              slide.getAttribute("data-swiper-slide-index")
            );
            const currentRealIndex = swiper.realIndex;

            if (clickedIndex === currentRealIndex) return;

            const slideToIndex = swiper.slides.findIndex(
              (s) =>
                parseInt(s.getAttribute("data-swiper-slide-index")) ===
                clickedIndex
            );

            if (slideToIndex >= 0) {
              swiper.slideTo(slideToIndex);
            }
          });
        });

        this.handleVideoAutoplay();
        this.sliderInstance.slider.on("slideChange", () =>
          this.handleVideoAutoplay()
        );

        this.calcNavButtonsPosition();
        this.calcHeadingColumnHeight();
        this.fixQuickviewDuplicate();
      }

      handleVideoAutoplay() {
        console.log("call handleVideoAutoplay");
        const swiper = this.sliderInstance?.slider;
        if (!swiper) return;

        const activeSlide = swiper.slides[swiper.activeIndex];
        if (!activeSlide) return;

        // Sabhi videos ko stop + reset karo
        swiper.slides.forEach((slide) => {
          const video = slide.querySelector("video");
          if (video) {
            video.pause();
            video.currentTime = 0;
            video.onended = null;
          }
        });

        const video = activeSlide.querySelector("video");

        if (video) {
          // 🟢 Agar slide me video hai → usko play karo
          video.play().catch(() => {});
          // Jab video end ho → agla slide dikhado
          video.onended = () => {
            swiper.slideNext();
          };
        } else {
          // 🟢 Agar video nahi hai → fallback (3 sec baad agla slide)
          clearTimeout(this.imageSlideTimer);
          this.imageSlideTimer = setTimeout(() => {
            // Tabhi slideNext karo jab wahi slide abhi bhi active hai
            if (swiper.slides[swiper.activeIndex] === activeSlide) {
              swiper.slideNext();
            }
          }, 3000);
        }
      }

      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        if (typeof this.sliderInstance !== "object") return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }

      calcNavButtonsPosition() {
        if (this.dataset.calcButtonPosition !== "true") return;

        const firstMedia = this.querySelector(".product-card__image-wrapper");
        if (firstMedia && firstMedia.clientHeight > 0) {
          this.section.style.setProperty(
            "--swiper-navigation-top-offset",
            parseInt(firstMedia.clientHeight) / 2 + "px"
          );
        }
      }

      calcHeadingColumnHeight() {
        if (this.dataset.calcHeadingColumnHeight !== "true") return;

        const firstMedia = this.querySelector(".product-card__image-wrapper");
        if (firstMedia && firstMedia.clientHeight > 0) {
          this.section.style.setProperty(
            "--heading-column-height",
            firstMedia.clientHeight + "px"
          );
        }
      }

      fixQuickviewDuplicate() {
        let modalIds = [];
        Array.from(this.querySelectorAll("quick-view-modal")).forEach(
          (modal) => {
            const modalID = modal.getAttribute("id");
            if (modalIds.includes(modalID)) {
              modal.remove();
            } else {
              modalIds.push(modalID);
            }
          }
        );
      }
    }
  );

  document
    .querySelector(".swiper-wrapper")
    .addEventListener("click", function (e) {
      const clickedSlide = e.target.closest(".swiper-slide");
      if (!clickedSlide) return;
      const realIndex = parseInt(clickedSlide.dataset.swiperSlideIndex);
      if (!isNaN(realIndex)) {
        swiper.slideToLoop(realIndex);
      }
    });

  // 🟢 Play video on first load
  window.addEventListener("load", () => {
    const video = document.querySelector(".swiper-slide-active video");
    if (video) video.play();
  });

  document.addEventListener("DOMContentLoaded", function () {
    const activeSlide = document.querySelector(
      ".swiper-slide-active .reels_video"
    );
    console.log('activeSlide');
    if (activeSlide) {
      const videoWidth = activeSlide.offsetWidth;
      console.log("Video width:", videoWidth);

      const wrappers = document.querySelectorAll(
        ".product-card__image-wrapper"
      );
      wrappers.forEach(function (wrapper) {
        wrapper.style.width = videoWidth + "px";
      });
    }
  });
}
